const searchToggle = document.getElementById('searchToggle');
const searchOverlay = document.getElementById('searchOverlay');

if (searchToggle && searchOverlay) {
  searchToggle.addEventListener('click', () => {
    const isOpen = searchOverlay.classList.toggle('open');
    searchToggle.setAttribute('aria-expanded', isOpen);

    if (isOpen) {
      searchOverlay.querySelector('input')?.focus();
    }
  });
}

const mobileNav = document.getElementById('mobileNav');
const scrim = document.getElementById('scrim');
const openBtn = document.getElementById('mobileNavOpen');
const closeBtn = document.getElementById('mobileNavClose');

function openNav() {
  mobileNav?.classList.add('open');
  scrim?.classList.add('open');
  document.body.style.overflow = 'hidden';
}

function closeNav() {
  mobileNav?.classList.remove('open');
  scrim?.classList.remove('open');
  document.body.style.overflow = '';
}

openBtn?.addEventListener('click', openNav);
closeBtn?.addEventListener('click', closeNav);
scrim?.addEventListener('click', closeNav);

// Currency Switcher
const trigger = document.getElementById('currencyTrigger');
const dropdown = document.getElementById('currencyDropdown');
const items = document.querySelectorAll('.currency-item:not(.separator)');

if (trigger && dropdown) {
  trigger.addEventListener('click', () => {
    trigger.classList.toggle('active');
    dropdown.classList.toggle('active');
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.currency-switcher')) {
      trigger.classList.remove('active');
      dropdown.classList.remove('active');
    }
  });

  items.forEach((item) => {
    item.addEventListener('click', () => {
      items.forEach((i) => i.classList.remove('active'));
      item.classList.add('active');

      const currencyCode = item.querySelector('.currency-code')?.textContent;

      if (currencyCode) {
        const span = trigger.querySelector('span');
        if (span) {
          span.textContent = currencyCode;
        }

        trigger.classList.remove('active');
        dropdown.classList.remove('active');

        document.dispatchEvent(
          new CustomEvent('currencyChanged', {
            detail: { currency: currencyCode }
          })
        );
      }
    });
  });
}



 (function () {

    // Coverage filter
    var buttons = document.querySelectorAll('.filters button');
    var cards = document.querySelectorAll('#media-grid .card');
    var empty = document.getElementById('media-empty');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute('data-filter');
        var shown = 0;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        cards.forEach(function (c) {
          var match = f === 'all' || c.getAttribute('data-cat') === f;
          c.hidden = !match;
          if (match) shown++;
        });
        if (empty) empty.style.display = shown ? 'none' : 'block';
      });
    });
  })();